import liff from "@line/liff";
import { useEffect, useState } from "react";

type LiffState = {
  isLoggedIn: boolean;
  isReady: boolean;
  error: Error | null;
  userId: string | null;
};

export const useLiff = () => {
  const [state, setState] = useState<LiffState>({
    isLoggedIn: false,
    isReady: false,
    error: null,
    userId: null,
  });

  useEffect(() => {
    const initLiff = async () => {
      try {
        await liff.init({ liffId: import.meta.env.VITE_LIFF_ID });

        if (!liff.isLoggedIn()) {
          liff.login();
          return;
        }

        const profile = await liff.getProfile();
        setState({
          isLoggedIn: true,
          isReady: true,
          error: null,
          userId: profile.userId,
        });
      } catch (error) {
        setState((prev) => ({
          ...prev,
          error: error instanceof Error ? error : new Error("LIFF init failed"),
          isReady: true,
        }));
      }
    };

    initLiff();
  }, []);

  return state;
};
